// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalContent_container__cxgMH","main":"ModalContent_main__e7Kld","content":"ModalContent_content__AghEq","footer":"ModalContent_footer__R3h1h"};